/**
 * AwsCredentialProvider.
 *
 * @copyright Realeyes OU. All rights reserved.
 */
import AWS from 'aws-sdk/global';
import Logger from '../Logger';

export default class AwsCredentialProvider {
    /**
     * Creates AwsCredentialProvider instance.
     * @param {ConfigurationManager} configurationManager entity to get configuration
     */
    constructor(configurationManager) {
        this.config = configurationManager.config;
        this.logger = new Logger('ACP', configurationManager.isDebugMode());
    }

    /**
     *
     * @param{boolean} force is a flag which used to update credentials
     * @return{Promise.<Object.<{
     * awsCredentials: Object.<AWS.Credentials>,
     * recieved: Date,
     * isExpired: function,
     * recievedCredentials: Object.<{
     *  AWSCredentials: Object.<{
     *   AccessKeyId: string,
     *   Expiration: string,
     *   SecretAccessKey: string,
     *   SessionToken: string,
     *   }>,
     *  DurationSeconds: int,
     *  IpAddress: string,
     *  UserAgent: string,
     *  }>}>>}
     */
    getCredentials(force) {
        this.logger.logDebug(`start to get aws creds, force-${force}`);
        return new Promise((resolve, reject) => {
            if (!this.credentials || force || this.credentials.isExpired()) {
                fetch(this.config.aws.credentialsServiceUrl)
                    .then((result) => result.json())
                    .then((credentials) => {
                        const creds = {};
                        creds.recievedCredentials = credentials;
                        creds.awsCredentials = new AWS.Credentials({
                            accessKeyId: credentials.AWSCredentials.AccessKeyId,
                            secretAccessKey: credentials.AWSCredentials.SecretAccessKey,
                            sessionToken: credentials.AWSCredentials.SessionToken,
                        });
                        creds.recieved = Date.now();
                        creds.isExpired = () => (Date.now() - creds.recieved) / 1000 > credentials.DurationSeconds;
                        this.credentials = creds;
                        this.logger.logDebug(`aws creds re-created: ${JSON.stringify(creds)}`);
                        resolve(this.credentials);
                    }, reject);
            } else {
                this.logger.logDebug('used previous aws creds');
                resolve(this.credentials);
            }
        });
    }
}
